import { render } from "./LayoutSistem.vue?vue&type=template&id=9b656e94"
import script from "./LayoutSistem.vue?vue&type=script&lang=js"
export * from "./LayoutSistem.vue?vue&type=script&lang=js"

import "./LayoutSistem.vue?vue&type=style&index=0&id=9b656e94&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__